import {
  ControlProps,
  isObjectControl,
  RankedTester,
  rankWith
} from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { useEffect } from 'react'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ObjectLayoutRenderer = (props: ControlProps) => {
  const { handleChange, data, path, visible, uischema } = props

  useEffect(() => {
    // eslint-disable-next-line
    let timeOut: any

    // eslint-disable-next-line prefer-const
    switch (path) {
      case 'spouse_home_add_qtn': {
        if (visible) {
          if (!data) {
            handleChange(path, {
              spouse_home_add: {}
            })
          }
          if (data && !('spouse_home_add' in data)) {
            handleChange(path, { spouse_home_add: {} })
          }
        } else {
          handleChange(path, {})
        }
        break
      }
      case 'spouse_home_add_qtn.spouse_home_add': {
        break
      }

      case 'spouse_home_add_qtn.spouse_mailing_address_question': {
        break
      }

      case 'spouse_home_add_qtn.spouse_mailing_address_question.spouse_mailing_address': {
        if (!visible && data !== undefined && JSON.stringify(data) != '{}') {
          handleChange(path, {})
        }
        if (visible && !data) {
          handleChange(path, {})
        }
        break
      }
      default: {
        if (visible) {
          if (!data) {
            handleChange(path, {})
          }
        } else {
          handleChange(path, {})
        }
        break
      }
    }

    return () => {
      if (timeOut) {
        clearTimeout(timeOut)
      }
    }
  }, [visible])

  return (
    <>
      {visible && uischema.label ? (
        <div className='custom-object-label' data-testid='object-label'>
          {uischema.label}
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export const objectLayoutRendererTester: RankedTester = rankWith(
  3,
  isObjectControl
)

export const customObjectRenderer =
  withJsonFormsControlProps(ObjectLayoutRenderer)
